
import { useState } from "react";
import { motion } from "framer-motion";
import { ChartTypeSelector } from "./chart/chart-type-selector";
import { ChartDisplay } from "./chart/chart-display";
import { getChartData, type ChartType } from "./chart/chart-data";

export function DemoChart() {
  const [chartType, setChartType] = useState<ChartType>("line");
  
  // Choose the appropriate data based on the chart type
  const chartData = getChartData(chartType);
  
  return (
    <div className="max-w-md mx-auto my-8">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="mb-6 text-center"
      >
        <h2 className="heading-3 mb-2">Performance Trends</h2>
        <p className="text-white dark:text-gray-200">
          Track player performance across games
        </p>
      </motion.div>
      
      <ChartTypeSelector 
        chartType={chartType} 
        onChartTypeChange={setChartType} 
      />
      
      <ChartDisplay 
        chartData={chartData} 
        chartType={chartType} 
      />
      
      <div className="text-center mt-4">
        <p className="text-xs text-white dark:text-gray-200">
          Track performance metrics over time with our interactive charts
        </p>
      </div>
    </div>
  );
}
